// extracted by mini-css-extract-plugin
module.exports = {"heading":"Text_heading__u0osA","metaDataText":"Text_metaDataText__ad_BO","postMetaText":"Text_postMetaText__owuAG"};